// extracted by mini-css-extract-plugin
export default {"container":"BestSeller_container__vm89z","tabs":"BestSeller_tabs__qwCiT","tab":"BestSeller_tab__lVcsL","active":"BestSeller_active__TQNez","books":"BestSeller_books__ToDmX"};